if (!customElements.get('media-gallery')) { 
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {

    constructor() {
      super();
      this.slider = this.querySelector('[id="images-slider"]');
      this.thumbnails = this.querySelector('.thumbnails-slider');
      this.dots = this.querySelector('[id^="GalleryThumbnails-dots"]');
      this.only_mobile_dots = this.querySelector('[data-mobile-thumbs]');
            

      if(!this.slider) return

      
      this.is_slider = this.slider.getAttribute("data-desktop-type") === "slider";
      this._selected = this.slider.querySelector('[data-selected]');
      this.autoheight = this.dataset.autoheight === "true";
      this.isLargeScreen = window.innerWidth > 850;      


      // Set initial selected
      this.handleSelected();

      // Variant-specific media filtering (alt text matching)
      this.setupVariantFilter();


      document.addEventListener('DOMContentLoaded', () => this.updateThumbnailsHeight());
      window.addEventListener('resize', () => this.updateThumbnailsHeight());

      const debouncedResize = debounce(this.handleSelected.bind(this), 250);
      window.addEventListener('resize', debouncedResize);



      if ('onscrollend' in window) {
        this.slider.addEventListener('scrollend', () => this.handleSelected());
      } else {
        let timer;
        this.slider.addEventListener('scroll', () => {
          clearTimeout(timer);
          timer = setTimeout(() => this.handleSelected(), 250);
        });
      }



      [...this.querySelectorAll('.thumbnail')].forEach(thumbnail=>{
        thumbnail.addEventListener('click', ()=>{
          this.updateThumbnail(thumbnail.getAttribute('data-skip'))
          this.sliderScroll(thumbnail.getAttribute('data-skip'))
        })
      })

      if (!this.thumbnails) return;      
      this.isVertical = this.thumbnails.getAttribute('data-inline') === "true";

    }


    disconnectedCallback() {
      if (this.unsubscribeVariantChange) this.unsubscribeVariantChange();
    }

    handleResize() {
      this.handleHeight()
    }

    setupVariantFilter() {
      const position = parseInt(this.dataset.colorOptionPosition, 10) || 0;
      if (!position) return;
      this.colorOptionPosition = position;

      const valuesScript = this.querySelector('script[data-color-option-values]');
      const rawValues = valuesScript ? this.safeParseJSON(valuesScript.textContent) : [];
      this.colorOptionValuesSet = new Set(
        (rawValues || [])
          .map((v) => String(v).trim().toLowerCase())
          .filter(Boolean)
      );

      if (this.colorOptionValuesSet.size === 0) return;

      this.variantStashes = {};

      const productInfo = this.closest('product-info');
      const initialVariantScript = productInfo && productInfo.querySelector('variant-selects [data-selected-variant]');
      const initialVariant = initialVariantScript ? this.safeParseJSON(initialVariantScript.textContent) : null;
      if (initialVariant) this.filterByVariant(initialVariant);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data && data.variant) this.filterByVariant(data.variant);
        });
      }
    }

    safeParseJSON(text) {
      try { return JSON.parse(text); } catch (e) { return null; }
    }

    getVariantStash(name) {
      if (!this.variantStashes) this.variantStashes = {};
      if (this.variantStashes[name]) return this.variantStashes[name];
      const stash = document.createElement('div');
      stash.hidden = true;
      stash.style.display = 'none';
      stash.setAttribute('data-variant-stash', name);
      this.appendChild(stash);
      this.variantStashes[name] = stash;
      return stash;
    }

    filterByVariant(variant) {
      if (!variant || !this.colorOptionValuesSet || this.colorOptionValuesSet.size === 0) return;
      if (!this.slider) return;

      const optionValues = variant.options || [];
      const currentColor = String(optionValues[this.colorOptionPosition - 1] || '').trim().toLowerCase();
      if (!currentColor) return;

      const shouldHide = (alt) => {
        const norm = (alt || '').trim().toLowerCase();
        if (!norm) return false;
        if (!this.colorOptionValuesSet.has(norm)) return false;
        return norm !== currentColor;
      };

      // Move filtered-out items into a hidden stash sibling so the slider's
      // firstElementChild and thumbnail layout reflect only visible media.
      const filterContainer = (container, stashName, sortAttr) => {
        if (!container) return [];
        const stash = this.getVariantStash(stashName);

        // Restore everything to the container, sorted by original index.
        const items = [...container.children, ...stash.children].sort((a, b) => {
          return parseInt(a.getAttribute(sortAttr) || '0', 10) - parseInt(b.getAttribute(sortAttr) || '0', 10);
        });
        items.forEach((item) => container.appendChild(item));

        const decisions = items.map((item) => ({ item, hide: shouldHide(item.dataset.variant) }));
        const visibleCount = decisions.reduce((n, d) => n + (d.hide ? 0 : 1), 0);

        // Defensive: if filtering would empty the container, leave everything visible.
        if (visibleCount === 0) {
          return decisions.map((d) => ({ item: d.item, hide: false }));
        }

        decisions.forEach(({ item, hide }) => {
          if (hide) stash.appendChild(item);
        });
        return decisions;
      };

      const sliderDecisions = filterContainer(this.slider, 'slider', 'data-image');
      filterContainer(this.querySelector('#GalleryThumbnails-images'), 'image-thumbs', 'data-skip');
      filterContainer(this.querySelector('#GalleryThumbnails-dots'), 'dot-thumbs', 'data-skip');

      const firstVisible = sliderDecisions.find((d) => !d.hide);
      if (!firstVisible) return;

      // If the previously selected slide was stashed, jump to the first visible one.
      if (!this.selected || this.selected.parentElement !== this.slider) {
        const firstVisibleIndex = firstVisible.item.getAttribute('data-image');
        this.sliderScroll(firstVisibleIndex);
        if (this.thumbnails) this.updateThumbnail(firstVisibleIndex);
      }
    }


    onSelectedChange(newValue) {  
      this.slider.dispatchEvent(new CustomEvent('selected:change', {
        detail: { selected: newValue }
      }));
      
    }

    handleSelected(){
        
        const sliderRect = this.slider.getBoundingClientRect();
        const sliderCenter = sliderRect.left + sliderRect.width / 2;

        let closestItem = null;
        let minDistance = Infinity;

        [...this.slider.children].forEach((item) => {
          if (!item.dataset.image) return; // Skip if no image data

          const itemRect = item.getBoundingClientRect();
          const itemCenter = itemRect.left + itemRect.width / 2;
          const distance = Math.abs(sliderCenter - itemCenter);

          if (distance < minDistance) {
            minDistance = distance;
            closestItem = item;
          }
        });


        if (closestItem) {
          if (this.thumbnails) {
            this.updateThumbnail(closestItem.getAttribute('data-image') * 1);
          }
          // 🔹 Use the unified update method so event & logic stay consistent
          this.updateSelected(closestItem);
          if (this.autoheight) {
            //this.updateHeight(1 * this.selected.dataset.height, 1 * this.selected.dataset.width);
            this.handleHeight(closestItem)
          }
          

          // Optionally: auto height adjustment or any follow-up logic
          /* if (this.autoheight && (this.is_slider || window.innerWidth <= 850)) {
            this.handleHeight();
          } */
        }

    }

    scrollToImage(selected){
          if (this.is_slider || window.innerWidth < 850) {
            const slider_x_start = this.slider.getBoundingClientRect().left;
            const selected_x = selected.getBoundingClientRect().left;
            const offset = selected_x - slider_x_start;
        
            this.slider.scrollTo({
            left: this.slider.scrollLeft + offset,
            behavior: 'instant' // 'auto' or remove this line if 'instant' doesn't work well
            });
        } else {
            const element_rect = selected.getBoundingClientRect();
            const scroll_target = window.scrollY + element_rect.top - (window.innerHeight / 2) + (element_rect.height / 2);
        
            window.scrollTo({
            top: scroll_target,
            behavior: "smooth"
            });
        }
    }

    sliderScroll(index){              
          const selected_element = this.slider.querySelector(`[data-image='${index}']`);
          if (!selected_element) return;

          this.scrollToImage(selected_element);

    }

    updateSelected(newElement) {
      if (!newElement) return;
      if (this.selected) this.selected.removeAttribute('data-selected');
      newElement.setAttribute('data-selected', 'true');
      this.selected = newElement; // triggers setter and onSelectedChange()
    }

    updateThumbnail(index) {
      if (!this.thumbnails || index === undefined) return;
    
      
      const thumbnails = this.thumbnails.querySelectorAll('.thumbnail');

      thumbnails.forEach(thumbnail => {
        if (thumbnail.getAttribute('data-skip') * 1 === index * 1) {
          thumbnail.classList.add('active');
          if (thumbnail.classList.contains('thumbnail_image')) {
            this.thumbnailScrollImages(thumbnail)
          }
        } else {
          thumbnail.classList.remove('active');
        }
      });
    }

    thumbnailScrollImages(thumbnail){
          const container = thumbnail.closest('.product_thumbnails')
          const containerRect = container.getBoundingClientRect();
          
          const thumbnailRect = thumbnail.getBoundingClientRect();          
    
          if (this.isVertical && this.isLargeScreen) {
            // Scroll Vertically if in vertical mode and screen is large
            const containerScrollTop = container.scrollTop;
            const scrollTo = containerScrollTop + (thumbnailRect.top + thumbnailRect.height / 2) - 
                             (containerRect.top + containerRect.height / 2);
            container.scrollTo({ top: scrollTo, behavior: 'smooth' });
          } else {

            
            // Scroll Horizontally (default for small screens or horizontal mode)
            const containerScrollLeft = container.scrollLeft;
            const scrollTo = containerScrollLeft + (thumbnailRect.left + thumbnailRect.width / 2) - 
                             (containerRect.left + containerRect.width / 2);
            container.scrollTo({ left: scrollTo, behavior: 'smooth' });
          }
    }

    updateThumbnailsHeight() {
      
      if (!this.slider || !this.thumbnails) return;
       
        const thumbnail_images = this.thumbnails.querySelector('#GalleryThumbnails-images')


        if (thumbnail_images) {
          const isVertical = this.thumbnails.getAttribute('data-inline') === "true";
          const isLargeScreen = window.innerWidth > 850;
        
          if (!isVertical || !isLargeScreen) {
            // Reset height if it's horizontal or on a small screen
            thumbnail_images.style.maxHeight = "";
            return;
          }
        
          const sliderHeight = this.slider.clientHeight;
          thumbnail_images.style.maxHeight = `${sliderHeight}px`;
        }
    
      
    }

    handleHeight(){
 
      if (this.is_slider || window.innerWidth < 850) {        
        if (this.autoheight && this.selected) {
          return  this.slider.style.height = `${ this.selected.offsetWidth * this.selected.dataset.height / this.selected.dataset.width }px`;
        }else {
          return  this.slider.style.height = "auto" 
        }
        
      }else{
        return  this.slider.style.height = "auto"
      }
    }

    get selected() {
      return this._selected;
    }

    set selected(newValue) {                  
      if (this._selected !== newValue) {
        this._selected = newValue;
        this.onSelectedChange(newValue);
      }
    }

  });
}